import React, { useState,useEffect } from 'react';

const CancellationModal = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure top scroll on page load
  }, []);
  const [selectedReason, setSelectedReason] = useState('');

  const handleReasonChange = (event) => {
    setSelectedReason(event.target.value);
  };

  const handleSubmit = () => {
    // Handle submit logic here
    console.log('Selected Reason:', selectedReason);
  };

  return (
    <div className="fixed  inset-0 flex items-center justify-center mt-20 bg-gray-800 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-80">
        <h2 className="text-lg font-bold mb-4">Reason for Cancellation</h2>
        <form>
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="modifyItems"
              name="cancellationReason"
              value="I want to modify Items in my order"
              checked={selectedReason === "I want to modify Items in my order"}
              onChange={handleReasonChange}
              className="mr-2"
            />
            <label htmlFor="modifyItems" className="text-sm">
              I want to modify Items in my order
            </label>
          </div>
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="boughtItems"
              name="cancellationReason"
              value="Bought Items from outside"
              checked={selectedReason === "Bought Items from outside"}
              onChange={handleReasonChange}
              className="mr-2"
            />
            <label htmlFor="boughtItems" className="text-sm">
              Bought Items from outside
            </label>
          </div>
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="delayInOrder"
              name="cancellationReason"
              value="Delay in order"
              checked={selectedReason === "Delay in order"}
              onChange={handleReasonChange}
              className="mr-2"
            />
            <label htmlFor="delayInOrder" className="text-sm">
              Delay in order
            </label>
          </div>
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="forgotCoupon"
              name="cancellationReason"
              value="Forgot to apply coupon"
              checked={selectedReason === "Forgot to apply coupon"}
              onChange={handleReasonChange}
              className="mr-2"
            />
            <label htmlFor="forgotCoupon" className="text-sm">
              Forgot to apply coupon
            </label>
          </div>
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="paymentIssues"
              name="cancellationReason"
              value="Facing Payment Related issues"
              checked={selectedReason === "Facing Payment Related issues"}
              onChange={handleReasonChange}
              className="mr-2"
            />
            <label htmlFor="paymentIssues" className="text-sm">
              Facing Payment Related issues
            </label>
          </div>
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="walletBalance"
              name="cancellationReason"
              value="Wallet Balance Issue"
              checked={selectedReason === "Wallet Balance Issue"}
              onChange={handleReasonChange}
              className="mr-2"
            />
            <label htmlFor="walletBalance" className="text-sm">
              Wallet Balance Issue
            </label>
          </div>
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="incorrectAddress"
              name="cancellationReason"
              value="Incorrect address"
              checked={selectedReason === "Incorrect address"}
              onChange={handleReasonChange}
              className="mr-2"
            />
            <label htmlFor="incorrectAddress" className="text-sm">
              Incorrect address
            </label>
          </div>
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="other"
              name="cancellationReason"
              value="Other"
              checked={selectedReason === "Other"}
              onChange={handleReasonChange}
              className="mr-2"
            />
            <label htmlFor="other" className="text-sm">
              Other
            </label>
          </div>
          <button
            type="button"
            onClick={handleSubmit}
            className="w-full bg-[#162C2A] text-white py-2 rounded hover:bg-bg-[#162C2A]"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default CancellationModal;
